//@ts-check
/**
 * 
 * @param {Fox} fox
 */
module.exports = (fox, parentPopupName ) => {
	require('common-widgets/PromisePopup.es')(fox, parentPopupName);

	return fox.registerWidget('GDPR_BasePopup', {
		configure() {
			this.registerOptions('', {
				preventHideOnShadowClick: true,
				dialog: {
					closeOnEscape: false,
				},
				onCancelPress: () => {
					this.hide();

					return fox.Promise.resolve(false);
				},
				handleWom: {
					blurOnShow: {
						event: 'show',
						widget: '@this',
						callback: () => fox.wom.getRoot().rdom1('.wrapper').classList.add('_opacity-40'),
						params: {
							prefix: 'gdpr_popups'
						}
					},
					blurOnHide: {
						event: 'hide',
						widget: '@this',
						callback: () => fox.wom.getRoot().rdom1('.wrapper').classList.remove('_opacity-40'),
						params: {
							prefix: 'gdpr_popups'
						}
					}
				}
			});

			this.callParent('configure', arguments);
		},

		init() {
			const onOkPress = this.requireOption('onOkPress');
			const onCancelPress = this.getOption('onCancelPress');

			this.registerOptions('#content', {
				template: this.getOption('contentTemplate'),
				handleDom: {
					close: {
						target: '.cancel-close'
					},
					onSuccess: {
						target: '#on-success',
						callback: (button, alias, context) =>
							onOkPress(button, context).then(
								(resp) => resp !== null && this.resolve(resp),
								(error) => this.reject(error)
							)
					},
					onCancel: {
						target: '#on-cancel',
						callback: (button, alias, context) =>
							onCancelPress(button, context).then(
								(resp) => resp !== null && this.resolve(resp),
								(error) => this.reject(error)
							)
					}
				}
			});
			
			window.addEventListener(fox.utils.isTouchDevice() ? 'orientationchange' : 'resize', () => {
				this._center();
			});

			this.setOption('dialog.dialogClass', `${this.getOption('dialog.dialogClass')} gdpr-popup`);

			this.callParent('init', arguments);
		},

		hide(mbEl, mbAlias) {
			if (mbAlias === 'close' && fox.dom.isDomNode(mbEl)) {
				this.resolve(false);
			}

			this.callParent('hide', arguments);
		}
	}, 'Popup_PromiseCommon');
}


// WEBPACK FOOTER //
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/common-components/GDPR-popups/widget/BasePopup.es.js